import Router from 'next/router';
import styles from './BlogProductCard.module.scss';
import Image from 'next/image';
import {
  pillsPacket,
  pillsWithShadow,
  pillWithShadow,
} from '../../../../../src/images';
import { Typography } from '@mui/material';
import { useRef, useState } from 'react';
import { RatingWithCount } from '../../../../../commons/hoc';

import imgLoader from '../../../../../imgloader';

const BlogProductCard = ({
  packet = false,
  title = '',
  image = '',
  segment = '',
  description = '',
  url = '/',
  reviewUrl = '',
  className = '',
  hidePills = false,
  price = '',
  rating = '',
  ...rest
}) => {
  const imgContainerRef = useRef(null);
  const [maxWidth, setmaxWidth] = useState('auto');
  return (
    <div className={`${styles.productCardContainer} ${className}`} {...rest}>
      <div
        className={`${styles.productImageWithPillContainer} ${
          !hidePills && styles.productImageWithoutPill
        }`}
        ref={imgContainerRef}
      >
        <div>
          <div
            onClick={() => Router.push(url)}
            className={styles.productImgContainer}
          >
            <Image
              alt={'Relief Factor Pain Relief'}
              layout="fill"
              src={image}
              loading="eager"
              blurDataURL={image}
              placeholder="blur"
              objectFit="contain"
              loader={imgLoader}
              className={styles.productImg}
            />
          </div>
        </div>
        {hidePills && (
          <div className={styles.pillsImgContainer}>
            <div
              onClick={() => Router.push(url)}
              className={styles.pillsWithShadowImgWrapper}
            >
              <div className={styles.pillsWithShadowImgContainer}>
                <Image
                  alt={'Relief Factor Pain Relief'}
                  layout="fill"
                  src={pillsWithShadow}
                  loading="eager"
                  loader={imgLoader}
                />
              </div>
            </div>
            {packet ? (
              <div
                onClick={() => Router.push(url)}
                className={styles.pillsPacketImgWraper}
              >
                <div className={styles.pillsPacketImgContainer}>
                  <Image
                    alt={'Relief Factor Pain Relief'}
                    layout="fill"
                    src={pillsPacket}
                    loading="eager"
                    loader={imgLoader}
                  />
                </div>
              </div>
            ) : (
              <div className={styles.pillWithShadowImgWrapper}>
                <div className={styles.pillWithShadowImgContainer}>
                  <Image
                    alt={'Relief Factor Pain Relief'}
                    layout="fill"
                    src={pillWithShadow}
                    loading="eager"
                    loader={imgLoader}
                  />
                </div>
              </div>
            )}
          </div>
        )}
      </div>
      <div className={styles.descriptionContainer}>
        <div style={{ maxWidth, width: maxWidth }}>
          <div className={styles.cardSubtitleContainer}>
            <Typography
              onClick={() => Router.push(url)}
              variant="h5"
              color="action.gray"
            >
              {segment}
            </Typography>
            {rating && (
              <div
                onClick={() =>
                  Router.push(
                    {
                      pathname: url,
                      hash: reviewUrl && 'review',
                    },
                    undefined,
                    {
                      scroll: false,
                    }
                  )
                }
              >
                <RatingWithCount
                  displayScore={false}
                  fetchFromYotpo={true}
                  product={rating}
                />
              </div>
            )}
          </div>
          <Typography
            onClick={() => Router.push(url)}
            variant="h4"
            color="primary.main"
          >
            {title}
          </Typography>
          <Typography
            onClick={() => Router.push(url)}
            className={styles.cardSubtitleDescription}
            variant="body2"
            color="primary.black"
          >
            {description}
          </Typography>
        </div>
        <div onClick={() => Router.push(url)} className={styles.subscribe}>
          <Typography variant="h5" color="primary.main">
            {price}
          </Typography>
          <Typography variant="h5" color="primary.black">
            When You Subscribe
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default BlogProductCard;
